var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-container"},[_c('p',{staticClass:"info-message"}),_c('p',{staticClass:"contact-us",domProps:{"innerHTML":_vm._s(_vm.contactUs)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }